import { TiltChartConfigDto, TiltChartDataDto } from 'types/CodegenReportTypes';

import { ChartProps } from 'utilities/chartIdToComponent';
import useReportStore from 'hooks/SessionReport/Pitcher/reportStore';
import TiltChart from 'components/Charts/TiltChart/TiltChart';

const PitcherSessionTiltChart = (props: ChartProps<TiltChartDataDto, TiltChartConfigDto>) => {
  const { selectedConfgValues } = useReportStore();

  return <TiltChart {...props} pitchGrouping={selectedConfgValues.pitchGrouping} />;
};

export default PitcherSessionTiltChart;
